import { useState } from 'react'
import { UserContext } from './UserContext'

import { ReactNode } from 'react'

type User = {
  name: string
  email: string
  image: string
  userIds: string[]
  hasOrgAccess: boolean
  hasPersonalLinksAccess: boolean
  organizationId?: string
}

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>()

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  )
}
